import { useContext } from 'react';

import type { ViewContextFilterValues } from '../../createDefaultsFromViewContext/types';
import { ListViewCreateSessionContext } from '../ListViewCreateSessionContext';
import type { CreateSession } from '../types';

/** For lists: hands the filters in view to the create surface the user is about to open. */
export function useStartCreateSession(): (session: CreateSession) => void {
    return useContext(ListViewCreateSessionContext).startCreateSession;
}

/** For create surfaces: reads the filters to prefill from, at the moment they are needed. */
export function useCreateDefaultsFilterValues(): () => ViewContextFilterValues {
    return useContext(ListViewCreateSessionContext).readCreateDefaultsFilterValues;
}
